































import { Component, Prop, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import IntegrationDto from '@/models/Integrations/IntegrationDto';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';
import { AgencySettingsModule } from '@/store/modules/agencySettings';

@Component({
  name: 'XeroAuthButton',
})
export default class XeroAuthButton extends GiganautVue {
  @Prop({ required: true }) integration!: IntegrationDto;
  
  loading = false;
  showError = false;
  errorMessage = '';

  get isXeroIntegration(): boolean {
    return this.integration && this.integration.integrationSystemId === IntegrationSystemIdConstants.Xero;
  }

  get buttonText(): string {
    // If the integration has settings, assume it's already connected
    if (this.integration && this.integration.settings && this.integration.settings.length > 0) {
      return 'Reconnect to Xero';
    }
    return 'Connect to Xero';
  }

  async authenticateWithXero(): Promise<void> {
    if (!this.isXeroIntegration) return;

    try {
      this.loading = true;
      
      // Call the backend API to get the Xero OAuth URL
      const response = await AgencySettingsModule.getXeroAuthUrl();
      
      if (response && response.url) {
        // Store the integration ID in the session storage for use upon return
        sessionStorage.setItem('xero_integration_id', this.integration.id);
        
        // Redirect the user to the Xero authorization URL
        window.location.href = response.url;
      } else {
        throw new Error('Invalid response from Xero authorization endpoint');
      }
    } catch (error) {
      this.errorMessage = 'Failed to connect to Xero. Please try again.';
      this.showError = true;
      console.error('Error connecting to Xero:', error);
    } finally {
      this.loading = false;
    }
  }
}
